import { render, staticRenderFns } from "./PatInfo.vue?vue&type=template&id=b3d8e4d4"
import script from "./PatInfo.vue?vue&type=script&lang=js"
export * from "./PatInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports